export const ROUTES = {
	test: '/test',

	auth: {
		registration: '/registration',
		login: '/login',
		hello: '/hello',
		passwordRecoveryCredentials: '/password_recovery_credentials',
		resetPasswordCode: '/reset_password_code',
		changePassword: '/change_password',
		confirmPassword: '/confirm_password',
		enterBaseInfo: '/enter_base_info',
		logout: '/logout',
	},

	overall: {
		intro: '/',
		hello: '/hello',
		main: '/main',
		review: '/review',
		profile: '/profile',
		profileEdit: '/profile/edit',
		aiMessenger: '/AImessenger',
		inviteFriends: '/InviteFriends',
		settings: '/settings',
		subscription: '/subscription',
		trainingConstructor: '/training_constructor',
		checkTechnique: '/check_technique',
		timer: '/timer',
		timerDetail: '/timer/:presetId',
		workoutHistory: '/workout_history',
		recentlySeenWorkouts: '/recently_seen_workouts',
		userAgreement: '/user_agreement',
		privacyPolicy: '/privacy_policy',
		aboutUs: '/about_us',
		pwaInstallationGuide: '/pwa_installation_guide',
	},

	program: {
		calendar: '/program/:enrollmentId/calendar',
		week: '/program/:enrollmentId/week/:weekNumber',
		trainingHistory: '/program/:enrollmentId/week/:weekNumber/day/:dayNumber/history',
		redirectProgram: '/program/:enrollmentId',
		redirectWeek: '/program/:enrollmentId/week',
	},

	programs: {
		program: '/program/:programId',
		exercise: '/program/:programId/training/exercise/',
		execution: '/program/:programId/training/exercise/execution',
		relax: '/program/:programId/training/exercise/relax',
		result: '/program/:programId/training/result',
	},

	training: {
		details: '/training/:trainingID',
		completed: '/training/:trainingID/completed',
		exercise: '/training/:trainingID/exercise/:exerciseOrder',
		cardioExecution: '/training/:trainingID/exercise/:exerciseOrder/cardio_execution',
		cardioRelax: '/training/:trainingID/exercise/:exerciseOrder/cardio_relax',
	},

	exercise: {
		exerciseInfo: '/exercise/:exerciseId',
	},

	trainings: {},

	premium: {
		checkExercise: '/check_exercise',
	},
}
